import { useState } from "react";

import { NavigateOptions, useLocation, useNavigate } from "react-router-dom";
import { SampleSubheader } from "../../../../components";
import { useGetReportSummary, useLocalSampleSummaryParams } from "../../hooks";
import { pathToSS } from "../../util";
import { useGetMergedRlcsReport } from "../rlcloudsandbox/hooks/useGetMergedRlcsReport";
import RlCloudSandoxScreenshotsModal from "../rlcloudsandbox/screenshots/RlCloudSandoxScreenshotsModal";
import {
  AuxiliaryAnalysis,
  DynamicAnalysis,
  Integrations,
  NetworkReferences,
  StaticAnalysis,
  ThreatIntelligenceAnalysis
} from "./card";

const ReportSummarySubheader = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const [showModal, setShowModal] = useState(false);
  const { hash = "", sourceId, relationshipId } = useLocalSampleSummaryParams();
  const { data } = useGetReportSummary(hash, sourceId, relationshipId);
  const { mergedReportData } = useGetMergedRlcsReport(hash ?? "");

  const { classification_decisive_reason: reason } = data ?? {};

  const handleClick = (section: string, options?: NavigateOptions) => {
    const path = pathToSS(hash, sourceId, section);
    navigate(`${path}${search}`, options);
  };

  return (
    <>
      <SampleSubheader>
        <SampleSubheader.Group>
          <StaticAnalysis
            decisive={reason === "core"}
            data={data?.static_analysis}
            onClick={handleClick}
          />
          <DynamicAnalysis
            decisive={reason === "cloud-sandbox"}
            onClick={handleClick}
            impactsFinalClassification={
              data?.cloud_sandbox_included_in_classification
            }
            onShowScreenshots={() => {
              setShowModal(true);
            }}
          />
          <ThreatIntelligenceAnalysis
            decisive={reason === "threat_intelligence"}
            data={data?.threat_intelligence}
            onClick={handleClick}
          />
        </SampleSubheader.Group>
        <SampleSubheader.Divider />
        <SampleSubheader.Group>
          <AuxiliaryAnalysis
            decisive={reason === "auxiliary-analysis"}
            data={data?.auxiliary_analysis}
            onClick={handleClick}
          />
          <NetworkReferences onClick={handleClick} />
          <Integrations
            reason={reason}
            data={data?.sandbox_analysis}
            onClick={handleClick}
          />
        </SampleSubheader.Group>
      </SampleSubheader>
      <RlCloudSandoxScreenshotsModal
        hash={hash ?? ""}
        historyAnalysis={mergedReportData?.history_analysis ?? []}
        showModal={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      />
    </>
  );
};

export default ReportSummarySubheader;
